import alt from 'components/Dispatcher';
import generateAsyncActions from 'utils/generateAsyncActions';
import {ActionsBase, DispatchAll, IncludeResultCallbacks} from '@store/@types/alt';
import {WebDataRocksSource} from './WebDataRocksSource';
import AnnotatedScorecardResult from 'records/AnnotatedScorecardResult';
import {WidgetConfig} from '@store/@types/dash';
import {UserId} from 'records/User';

export const xlsxDateFormat = 'MM/DD/YYYY';

export enum WebDataType {
  SW_REP = 'REP_SCORECARDS',
  SW_TEAM = 'TEAM_SCORECARDS',
  COACHING_ACTIVITY = 'COACHING_ACTIVITY',
  MANAGER_COACHING_ACTIVITY = 'MANAGER_COACHING_ACTIVITY',
  NINE_BOX_METRICS = 'NINE_BOX_METRICS',
  COACHING_PLAN = 'COACHING_PLAN',
  ADMIN_USERS = 'ADMIN_USERS',
}

interface AsyncActions {
  fetchData(
    params: WidgetConfig,
    managerId: UserId | undefined
  ): Promise<AnnotatedScorecardResult[]>;
  getLicenseKey(): Promise<string | null>;
}

interface SyncActions {
  hideDialog(): void;
  showDialog(title: string): void;
  resetToDefault(): void;
  setData(dataType: WebDataType, data: any[]): void;
}
export interface WebDataRocksActionsInterface
  extends IncludeResultCallbacks<AsyncActions>,
    SyncActions {}

class WebDataRocksActions
  extends ActionsBase<AsyncActions, SyncActions>()
  implements DispatchAll<AsyncActions>
{
  constructor() {
    super();
    this.generateActions(
      'showDialog',
      'hideDialog',
      'resetToDefault',
      'setData',
      ...generateAsyncActions<AsyncActions>('fetchData', 'getLicenseKey')
    );
  }

  fetchData(params, managerId) {
    return dispatch => {
      dispatch([params, managerId]);
      return WebDataRocksSource.fetchData(params, managerId).then(
        this.fetchDataSuccess,
        this.fetchDataError
      );
    };
  }

  getLicenseKey() {
    return dispatch => {
      dispatch();
      return WebDataRocksSource.getLicenseKey().then(
        this.getLicenseKeySuccess,
        this.getLicenseKeyError
      );
    };
  }
}

export default alt.createActions<AsyncActions, SyncActions>(WebDataRocksActions);
